const { LocaleUrlStrategy } = require('@akinon/next/localization');
const { ROUTES } = require('@theme/routes');

const commerceUrl = encodeURI(process.env.SERVICE_BACKEND_URL ?? 'default');

/** @type {import('@akinon/next/types').Settings} */
module.exports = {
  webVitals: {
    enabled: true
  },
  commerceUrl,
  commerceRedirectionIgnoreList: ['/users/reset'],
  commonProductAttributes: [
    { translationKey: 'color', key: 'color' },
    { translationKey: 'size', key: 'size' },
    { translationKey: 'size_variant', key: 'size_variant' }
  ],
  localization: {
    locales: [
      {
        label: 'TR',
        value: 'tr',
        localePath: 'tr',
        apiValue: 'tr-tr',
        rtl: false
      }
    ],
    currencies: [
      {
        label: 'TL',
        code: 'try'
      }
    ],
    defaultLocaleValue: 'tr',
    localeUrlStrategy: LocaleUrlStrategy.HideDefaultLocale,
    redirectToDefaultLocale: true,
    defaultCurrencyCode: 'try'
  },
  rewrites: [
    {
      source: ROUTES.AUTH,
      destination: '/auth'
    },
    {
      source: ROUTES.BASKET,
      destination: '/basket'
    },
    {
      source: ROUTES.ACCOUNT_ORDERS,
      destination: '/account/orders'
    },
    {
      source: '/tani',
      destination: '/tani'
    }
  ],
  redis: {
    defaultExpirationTime: 900 // 15 min
  },
  customNotFoundEnabled: false
};
